<template lang="pug">
#daily-statement.tab-pane.fade.show.active
  .statement-wrapper(v-if="showDetails")
    detailReport(:category="category" )
  .statement-wrapper(v-else)
    .statement-mobile
      .statement-single(v-for="statement in statementList")
        .statement-single-content
          .statement-date {{ $moment(statement.working_date).format("YYYY-MM-DD") }}
          .statement-detail
            .statement-detail-left {{ $t("ui.deposit") }}
            .statement-detail-right
              a(:class="getColor(statement.deposit_amount)" href="javascript:void(0);" @click.stop="getMemberTransferDetails(statement.working_date, statement.deposit_amount != 0);") {{statement.deposit_amount}}
                i.fa-solid.fa-circle-chevron-right.ms-1(v-if="statement.deposit_amount != 0")
          .statement-detail
            .statement-detail-left {{ $t("ui.withdrawal") }}
            .statement-detail-right
              a(:class="getColor(statement.withdrawal_amount)" href="javascript:void(0);" @click.stop="getMemberTransferDetails(statement.working_date, statement.withdrawal_amount != 0);") {{statement.withdrawal_amount}}
                i.fa-solid.fa-circle-chevron-right.ms-1(v-if="statement.withdrawal_amount != 0")
          .statement-detail
            .statement-detail-left
              span.statement-win(:class="getColor(statement.winlose)") {{ $t(getText(statement.winlose)) }}
            .statement-detail-right
              a.text-green(href="javascript:void(0);" :class="getColor(statement.winlose)" @click.stop="getPlatformWinLose(statement.working_date);") {{statement.winlose}}
                i.fa-solid.fa-circle-chevron-right.ms-1
          .statement-detail
            .statement-detail-left {{ $t("ui.promotion_bonus") }}
            .statement-detail-right
              a(href="javascript:void(0);" :class="getColor(statement.bonus_amount)" @click.stop="getPromoStatement(statement.working_date);") {{statement.bonus_amount}}
                i.fa-solid.fa-circle-chevron-right.ms-1
          .statement-detail
            .statement-detail-left {{ $t("ui.adjustment") }}
            .statement-detail-right
              a(href="javascript:void(0);" :class="getColor(statement.adjustment_amount)" @click.stop="getAdjustmentDetails(statement.working_date);") {{statement.adjustment_amount}}
                i.fa-solid.fa-circle-chevron-right.ms-1
          .statement-detail
            .statement-detail-left {{ $t("ui.referee") }}
            .statement-detail-right
              a(href="javascript:void(0);" :class="getColor(statement.referee_count)" @click.stop="getRefereeList(statement.working_date);") {{statement.referee_count}}
                i.fa-solid.fa-circle-chevron-right.ms-1
          .statement-balance
            .statement-balance-left {{ $t("ui.balance") }}
            .statement-balance-right {{statement.closing_balance}}
    .statement-desktop
      .table-responsive
        table.table-history
          tr
            th.text-capitalize {{ $t('ui.date') }}
            th.text-capitalize {{ $t('ui.winlose') }}
            th.text-capitalize {{ $t('ui.deposit') }}
            th.text-capitalize {{ $t('ui.withdrawal') }}
            th.text-capitalize {{ $t('ui.promotion_bonus') }}
            th.text-capitalize {{ $t('ui.adjustment') }}
            th.text-capitalize {{ $t('ui.referee') }}
            th.text-capitalize {{ $t('ui.balance') }}
          tr(v-for="statement in statementList")
            td {{ $moment(statement.working_date).format("YYYY-MM-DD") }}
            td
              a(href="javascript:void(0);" :class="getColor(statement.winlose)" @click.stop="getPlatformWinLose(statement.working_date);") {{statement.winlose}}
            td
              a(href="javascript:void(0);" :class="getColor(statement.deposit_amount)" @click.stop="getMemberTransferDetails(statement.working_date, statement.deposit_amount != 0);") {{statement.deposit_amount}}
            td
              a(href="javascript:void(0);" :class="getColor(statement.withdrawal_amount)" @click.stop="getMemberTransferDetails(statement.working_date, statement.withdrawal_amount != 0);") {{statement.withdrawal_amount}}
            td
              a(href="javascript:void(0);" :class="getColor(statement.bonus_amount)" @click.stop="getPromoStatement(statement.working_date);") {{statement.bonus_amount}}
            td
              a(href="javascript:void(0);" :class="getColor(statement.adjustment_amount)" @click.stop="getAdjustmentDetails(statement.working_date);") {{statement.adjustment_amount}}
            td
              a(href="javascript:void(0);" :class="getColor(statement.referee_count)" @click.stop="getRefereeList(statement.working_date);") {{statement.referee_count}}
            td {{statement.closing_balance}}
</template>
<script>
import detailReport from '@/component/statement/_detailReport.vue'
export default {
  components:{
    detailReport
  },
  data() {
    return {
      statementList: [],
      feedback: {
        success: "",
        status: ""
      },
      showDetails: false,
      category: ""
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  mounted(){
    this.getMemberStatement()
  },
  methods:{
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-danger";
      } else {
        return "no-deco";
      }
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    },
    getMemberStatement() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberStatement", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.statementList = response.data
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getMemberTransferDetails(working_date, mode) {
      if (!mode) return
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberTransferDetails", { account_id, working_date, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sTransferDetails", response.data)
                .then(() => {
                  this.showDetails = true
                  this.category = 0
                  this.$emit("reportSelected", this.category)
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getPlatformWinLose(working_date, page_size, page_number) {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPlatformWinLose", { account_id, working_date, page_size, page_number, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$emit("showBetHistory", {
                data: response.data
              })
              // this.$store
              //   .dispatch("user/sBetHistory", { data: response.data, size: 10, index: 1, working_date: working_date })
              //   .then(() => {
              //   })
              //   .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getPromoStatement(working_date) {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromoStatement", { account_id, working_date, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sPromoDetails", response.data)
                .then(() => {
                  this.showDetails = true
                  this.category = 1
                  this.$emit("reportSelected", this.category)
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getAdjustmentDetails(working_date){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getAdjustmentDetails", { account_id, working_date, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sAdjustmentDetails", response.data)
                .then(() => {
                  this.showDetails = true
                  this.category = 2
                  this.$emit("reportSelected", this.category)
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getRefereeList(date){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let working_date = this.$moment(date).format("YYYY-MM-DD")
        this.$store
          .dispatch("user/getRefereeList", { account_id, auth_token,working_date })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sRefereeCount", response.data)
                .then(() => {
                  this.showDetails = true
                  this.category = 3
                  this.$emit("reportSelected", this.category)
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    reset(){
      this.showDetails = false
    }
  }
}
</script>
<style lang="scss" scoped>
.table-statement-col{
  // white-space: nowrap;
  line-height: 1;
  text-align: center;
}
.custom-adjust{
  text-transform: inherit;
}
</style>